<template>
  <div>
    <!-- 服务商信息 -->
    <div class="trade-order-block">
      <!-- 服务商信息 -->
      <div class="block-title">服务商信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <!-- 服务商联系人 -->
          <el-col :span="3">服务商联系人</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorContactPerson }}</el-col>

          <!-- 服务商联系电话 -->
          <el-col :span="3">服务商联系电话</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorContactPhone }}</el-col>
        </el-row>
        <el-row class="content-row">
          <!-- 服务商编码 -->
          <el-col :span="3">服务商编码</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorCode }}</el-col>

          <!-- 服务商名称 -->
          <el-col :span="3">服务商名称</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <!-- 税率 -->
          <el-col :span="3">税率</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.taxRate * 100 }}%</el-col>
        </el-row>
      </div>
      <!--测量设计报价  -->
      <div
        v-if="
          (tradeApplyInfoVO.solutionStatus !== null &&
            tradeApplyInfoVO.solutionStatus > '230') ||
          tradeApplyInfoVO.bccProcessClientName
        "
      >
        <div class="block-title" style="margin-top: 26px">
          测量设计报价
          <el-button
            v-if="!this.tradeApplyAcceptanceVO.verifyItemDetailList"
            size="mini"
            class="downBtn"
            plain
            @click="getDownloadQuotation(tradeApplyInfoVO.applyId)"
          >下载报价单</el-button>
        </div>
        <div class="block-content">
          <el-row class="content-row">
            <!-- 服务商联系人 -->
            <el-col :span="3">报价日期</el-col>
            <el-col :span="9">{{ tradeApplyInfoVO.quoteDate | parseTime("{y}-{m}-{d}") }}</el-col>
            <el-col :span="4">报价金额</el-col>
            <el-col :span="8">
              {{ (tradeApplyInfoVO.quoteAmount/1).toFixed(2) | thousandSymbol }}元
              <el-button
                v-if="
                  this.tradeApplyAcceptanceVO.verifyItemDetailList &&
                  this.tradeApplyAcceptanceVO.verifyItemDetailList !== '' && this.tradeApplyAcceptanceVO !== []
                "
                size="mini"
                class="orderList"
                @click="seeQuatation"
              >查看{{ tradeApplyInfoVO.execTypeSubName }}报价单</el-button>
              <el-button v-else size="mini" class="quoteRecord" @click="submitRecord">查看报价提交记录</el-button>
            </el-col>
          </el-row>

          <el-row class="content-row">
            <el-col :span="3">资料上传人</el-col>
            <el-col :span="9">{{ tradeApplyInfoVO.tradeQuotedPerson }}</el-col>

            <el-col :span="4">资料上传时间</el-col>
            <el-col :span="8">
              {{
              tradeApplyInfoVO.tradeQuotedDate
              | parseTime("{y}-{m}-{d} {h}:{i}")
              }}
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">预计制作时长</el-col>
            <el-col :span="9">{{ tradeApplyInfoVO.estMakeDays }}&nbsp;天</el-col>
            <el-col :span="4" v-if="tradeApplyInfoVO.execTypeSubName == '批量化物料'">服务商预计投入门店数量</el-col>
            <el-col :span="8">{{ tradeApplyInfoVO.actualPocQty | thousandSymbol }}</el-col>
          </el-row>
          <!-- <el-row class="content-row" v-show="tradeApplyInfoVO.tradeQuotedCheckPerson">
            <el-col :span="3">资料确认人</el-col>
            <el-col :span="9">
              {{
              tradeApplyInfoVO.tradeQuotedCheckPerson
              }}
            </el-col>

            <el-col :span="4">资料确认时间</el-col>
            <el-col :span="8">
              {{
              tradeApplyInfoVO.tradeQuotedCheckDate
              | parseTime("{y}-{m}-{d} {h}:{i}")
              }}
            </el-col>
          </el-row>-->
          <el-row class="content-row">
            <el-col :span="3">报价备注</el-col>
            <el-col :span="21">
              <div v-if="tradeApplyInfoVO.quoteRemark">{{ tradeApplyInfoVO.quoteRemark }}</div>
              <div v-else>暂无</div>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">资料文件</el-col>
            <el-col :span="21" class="detail-file">
              <div v-for="(item, index) in planList" :key="index" class="detail-file-content">
                <el-image
                  v-if="item.acceptanceCode[0] === 'I'"
                  :src="getImg(item.fileUri)"
                  :preview-src-list="getPreviewImageList(planList)"
                  fit="cover"
                  class="img-wrapper__item"
                />
                <img v-else src="@/assets/images/PDF.png" @click="handleViewFile(getImg(item.fileUri))" />
                <div class="img-wrapper-title imgWarpTitle">{{ item.acceptanceName }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 完工证明 -->
      <div
        v-if="
          this.tradeApplyAcceptanceVO.verifyItemDetailList &&
          this.tradeApplyAcceptanceVO.verifyItemDetailList !== '' && this.tradeApplyAcceptanceVO.verifyItemDetailList !== []
        "
      >
        <div class="block-title" style="margin-top: 50px">
          完工证明
          <el-button size="mini" class="downBtn" plain @click="getDownloadQuotation(tradeApplyInfoVO.applyId)">下载报价单</el-button>
        </div>
        <div class="block-content">
          <el-row class="content-row">
            <!-- 服务商联系人 -->
            <el-col :span="3">上传完工证明日期</el-col>
            <el-col :span="9">
              {{
              tradeApplyInfoVO.acceptanceCheckDate | parseTime("{y}-{m}-{d}")
              }}
            </el-col>
            <el-col :span="3">报价单是否修改</el-col>
            <el-col :span="9">
              {{
              tradeApplyInfoVO.quoteAmount == tradeApplyInfoVO.actualAmount
              ? "未修改"
              : "已修改"
              }}
            </el-col>
          </el-row>

          <!-- <el-row class="content-row" v-show="tradeApplyInfoVO.verifyPerson">
            <el-col :span="3">资料审核人</el-col>
            <el-col :span="9">{{ tradeApplyInfoVO.verifyPerson }}</el-col>

            <el-col :span="3">资料审核时间</el-col>
            <el-col :span="9">
              {{
              tradeApplyInfoVO.verifyDate | parseTime("{y}-{m}-{d} {h}:{i}")
              }}
            </el-col>
          </el-row>-->
          <el-row class="content-row">
            <el-col :span="3">报价金额</el-col>
            <el-col :span="9">
              {{ (tradeApplyInfoVO.quoteAmount/1).toFixed(2) | thousandSymbol }}元
              <el-button size="mini" class="quoteRecord" @click="submitRecord">查看报价提交记录</el-button>
            </el-col>
            <el-col :span="3">完工报价金额</el-col>
            <el-col :span="9">
              {{
              (tradeApplyInfoVO.actualAmount/1).toFixed(2) | thousandSymbol
              }}元
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">资料提交人</el-col>
            <el-col :span="9">{{ tradeApplyInfoVO.acceptanceCheckPerson }}</el-col>

            <el-col :span="3">资料提交时间</el-col>
            <el-col :span="9">
              {{
              tradeApplyInfoVO.acceptanceCheckDate
              | parseTime("{y}-{m}-{d} {h}:{i}")
              }}
            </el-col>
          </el-row>
          <el-row class="content-row" v-if="tradeApplyInfoVO.quoteAmount != tradeApplyInfoVO.actualAmount">
            <el-col :span="3">报价修改原因</el-col>
            <el-col :span="21">{{ tradeApplyInfoVO.quoteModifyReason }}</el-col>
          </el-row>

          <el-row class="content-row">
            <el-col :span="3">完工信息备注</el-col>
            <el-col :span="21">
              <div v-if="tradeApplyInfoVO.dsxAcceptanceInfo">{{ tradeApplyInfoVO.dsxAcceptanceInfo }}</div>
              <div v-else>暂无</div>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">资料文件</el-col>
            <el-col :span="21" class="detail-file">
              <div v-for="(item, index) in acceptanceList" :key="index" class="detail-file-content">
                <el-image
                  v-if="item.acceptanceCode[0] === 'I'"
                  :src="getImg(item.fileUri)"
                  :preview-src-list="getPreviewImageList(acceptanceList)"
                  fit="cover"
                  class="img-wrapper__item"
                />
                <img v-else src="@/assets/images/PDF.png" @click="handleViewFile(getImg(item.fileUri))" />
                <div class="img-wrapper-title imgWarpTitle">{{ item.acceptanceName }}</div>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row class="content-row" v-if="hasSupplierQuote()"> -->
        </div>
      </div>

      <el-row
        class="content-row"
        v-if="
          (tradeApplyInfoVO.solutionStatus !== null &&
            tradeApplyInfoVO.solutionStatus > '230') ||
          tradeApplyInfoVO.bccProcessClientName
        "
        style="margin-top: 50px"
      >
        <el-table
          :data="processOrderList"
          style="width: 100%"
          max-height="530"
          :header-cell-style="{
            backgroundColor: '#ebf4ff',
            'text-align': 'center',
            color: 'rgba(13, 13, 13, 72)',
            fontSize: '15px',
            'font-family': ' Microsoft Yahei',
          }"
        >
          <el-table-column type="index" label="序号" align="center" width="55" fixed></el-table-column>
          <el-table-column property="itemTypeName" label="类别" width="93" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.itemId">{{ scope.row.itemTypeName }}</div>
              <div v-else>清单外物料</div>
            </template>
          </el-table-column>
          <el-table-column align="center" property="itemName,itemCode" width="238" label="部件">
            <!-- 使用作用域插槽，可以获取这一行返回的数据 -->
            <template slot-scope="scope">
              <div v-if="scope.row.itemId">
                {{ scope.row.itemCode }}-{{ scope.row.itemName }}&nbsp;
                <el-tooltip class="item" effect="dark" :content="scope.row.itemDesc" placement="right-start" popper-class="tps">
                  <i class="el-icon-question" style="cursor: pointer"></i>
                </el-tooltip>
              </div>
              <div v-else>{{ scope.row.itemName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" property="itemLength" width="70" label="长(米)">
            <!-- 使用作用域插槽，可以获取这一行返回的数据 -->
            <template slot-scope="scope">
              <div
                v-if="scope.row.itemLength  !== null && scope.row.itemLength !== ''"
              >{{ (scope.row.itemLength/1).toFixed(3) | thousandSymbol }}</div>
              <div v-else>/</div>
            </template>
          </el-table-column>
          <el-table-column align="center" property="itemWidth" label="宽/深(米)" width="92">
            <template slot-scope="scope">
              <div
                v-if="scope.row.itemWidth !== null && scope.row.itemWidth !== ''"
              >{{ (scope.row.itemWidth/1).toFixed(3) | thousandSymbol }}</div>
              <div v-else>/</div>
            </template>
          </el-table-column>
          <el-table-column align="center" property="itemHeight" width="68" label="高(米)">
            <template slot-scope="scope">
              <div
                v-if="scope.row.itemHeight !== null && scope.row.itemHeight !== '' "
              >{{ (scope.row.itemHeight/1).toFixed(3) | thousandSymbol }}</div>
              <div v-else>/</div>
            </template>
          </el-table-column>
          <el-table-column align="center" property="itemUnit" width="62" label="单位"></el-table-column>
          <el-table-column align="center" property="unitQty" width="85" label="单位数量">
            <template slot-scope="scope">
              {{
              (+scope.row.unitQty).toFixed(3) | thousandSymbol
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" property="manualQty" width="82" label="物料数量">
            <template slot-scope="scope">
              {{
              scope.row.manualQty | thousandSymbol
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="75" property="itemPrice" label="单价">
            <template slot-scope="scope">
              {{
              (scope.row.itemPrice/1).toFixed(2) | thousandSymbol
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" property="itemSum" width="83" label="小计(元)">
            <template slot-scope="scope">
              {{
              (scope.row.itemSum/1).toFixed(2) | thousandSymbol
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" property="underWarranty" width="73" label="质保期"></el-table-column>
          <el-table-column align="center" width="100" property="useScene" label="使用场景"></el-table-column>
        </el-table>
      </el-row>
      <el-row
        class="totalPrice"
        v-if="
          (tradeApplyInfoVO.solutionStatus !== null &&
            tradeApplyInfoVO.solutionStatus > '230') ||
          tradeApplyInfoVO.bccProcessClientName
        "
      >
        <el-col :span="24" class="totalmarginLeft">
          总计:
          <span>
            {{
            (totalAmount/1).toFixed(2) | thousandSymbol
            }}
          </span>元
        </el-col>
      </el-row>
      <el-row
        class="content-row red-col"
        v-if="
          (tradeApplyInfoVO.solutionStatus !== null &&
            tradeApplyInfoVO.solutionStatus > '230') ||
          tradeApplyInfoVO.bccProcessClientName
        "
      >
        <el-col :span="12">以上价格均为不含税价格</el-col>
        <el-col :span="12" :offset="17">
          清单外物料金额占比:{{
            ((tradeApplyAcceptanceVO.verifyItemDetailList ? tradeApplyInfoVO.finishOutOfListItemRate : tradeApplyInfoVO.quotaOutOfListItemRate) * 100).toFixed(2)
          }}%
        </el-col>
      </el-row>
    </div>

    <!-- 查看报价提交记录 -->
    <el-dialog title="提交报价记录" :visible.sync="dialogTableVisible" >
      <el-button  size="mini" class="dialog-button" @click="exportHistory(tradeApplyInfoVO.applyId)">导出历史报价信息</el-button>
      <el-table
        :data="processRecordList"
        border
        :header-cell-style="{
          background: 'rgba(0, 0, 0, 0.02)',
          'text-align': 'center',
          color: 'rgba(13, 13, 13, 72)',
          'font-family': ' Microsoft Yahei',
        }"
      >
        <el-table-column property="applyNumber" label="订单编号" width="150" align="center"></el-table-column>
        <el-table-column property="processActionName" label="操作" width="200" align="center"></el-table-column>
        <el-table-column align="center" property="processClientName" label="操作人"></el-table-column>
        <el-table-column align="center" property="processTime" width="180" label="操作时间">
          <template slot-scope="scope">{{ scope.row.processTime | parseTime("{y}-{m}-{d} {h}:{i}") }}</template>
        </el-table-column>
        <el-table-column align="center" property="processData" label="总金额" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.processData === null">暂无</div>
            <div v-else>
              {{
              ((scope.row.processData.split("_")[1])/1).toFixed(2) | thousandSymbol
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-red" size="small" @click="dialogTableVisible = false">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看{{}}报价单 -->
    <el-dialog :title="'查看' + tradeApplyInfoVO.execTypeSubName + '报价单'" :visible.sync="dialogTableOrderVisible" width="1220px">
      <el-table
        :data="quoteItemDetailList"
        style="width: 100%"
        max-height="530"
        :header-cell-style="{
          backgroundColor: '#ebf4ff',
          'text-align': 'center',
          color: 'rgba(13, 13, 13, 72)',
          fontSize: '15px',
          'font-family': ' Microsoft Yahei',
        }"
      >
        <el-table-column type="index" label="序号" align="center" width="55" fixed></el-table-column>
        <el-table-column property="itemTypeName" label="类别" width="90" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.itemId">{{ scope.row.itemTypeName }}</div>
            <div v-else>清单外物料</div>
          </template>
        </el-table-column>
        <el-table-column align="center" property="itemName,itemCode" width="238" label="部件">
          <!-- 使用作用域插槽，可以获取这一行返回的数据 -->
          <template slot-scope="scope">
            <div v-if="scope.row.itemId">
              {{ scope.row.itemCode }}-{{ scope.row.itemName }}&nbsp;
              <el-tooltip class="item" effect="dark" :content="scope.row.itemDesc" placement="right-start" popper-class="tps">
                <i class="el-icon-question" style="cursor: pointer"></i>
              </el-tooltip>
            </div>
            <div v-else>{{ scope.row.itemName }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" property="itemLength" width="68" label="长(米)">
          <!-- 使用作用域插槽，可以获取这一行返回的数据 -->
          <template slot-scope="scope">
            <div
              v-if="scope.row.itemLength  !== null && scope.row.itemLength !== ''"
            >{{ (scope.row.itemLength/1).toFixed(3) | thousandSymbol }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column align="center" property="itemWidth" label="宽/深(米)" width="92">
          <template slot-scope="scope">
            <div
              v-if="scope.row.itemWidth  !== null && scope.row.itemWidth !== ''"
            >{{ (scope.row.itemWidth/1).toFixed(3) | thousandSymbol }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column align="center" property="itemHeight" width="68" label="高(米)">
          <template slot-scope="scope">
            <div
              v-if="scope.row.itemHeight  !== null && scope.row.itemHeight !== ''"
            >{{ (scope.row.itemHeight/1).toFixed(3) | thousandSymbol }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column align="center" property="itemUnit" width="62" label="单位"></el-table-column>
        <el-table-column align="center" property="unitQty" width="85" label="单位数量">
          <template slot-scope="scope">
            {{
            (scope.row.unitQty/1).toFixed(3) | thousandSymbol
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" property="manualQty" width="82" label="物料数量">
          <template slot-scope="scope">
            {{
            scope.row.manualQty | thousandSymbol
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" width="75" property="itemPrice" label="单价">
          <template slot-scope="scope">
            {{
            (scope.row.itemPrice/1).toFixed(2) | thousandSymbol
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" property="itemSum" width="83" label="小计(元)">
          <template slot-scope="scope">
            {{
            (scope.row.itemSum/1).toFixed(2) | thousandSymbol
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" property="underWarranty" width="73" label="质保期"></el-table-column>
        <el-table-column align="center" width="100" property="useScene" label="使用场景"></el-table-column>
      </el-table>
      <el-row class="totalPrice">
        <el-col :span="24" :offset="21">
          总计:
          <span>
            {{
            (tradeApplyInfoVO.quoteAmount/1).toFixed(2) | thousandSymbol
            }}
          </span>元
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-row class="content-row red-col">
          <el-col :span="8">以上价格均为不含税价格</el-col>
          <el-col :span="3" :offset="6">
            <el-button class="btn-red" size="small" @click="dialogTableOrderVisible = false">确 定</el-button>
          </el-col>
          <el-col :span="6" :offset="8">
            清单外物料金额占比:{{
            (tradeApplyInfoVO.quotaOutOfListItemRate * 100).toFixed(2)
            }}%
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <v-form ref="form" :url="exportUrl" />
  </div>
</template>

<script>
import vForm from '@/components/v-form'
import { commonUtils } from '@/utils/common'
export default {
  name: 'store-base-info',
  props: {
    tradeApplyOrderVO: {},
    tradeApplyInfoVO: {},
    tradeApplyBaseVO: {}
  },
  components: {
    vForm
  },
  data () {
    return {
      tradeApplyObj: {},
      dialogTableVisible: false,
      dialogTableOrderVisible: false,
      formLabelWidth: '120px',
      shopList: [],
      shopShowList: [],
      processRecordList: [], // 报价提交记录数据
      exportUrl: null
    }
  },
  computed: {
    totalAmount () {
      if (this.tradeApplyInfoVO.applyStatus > 200 && this.tradeApplyInfoVO.actualAmount && this.tradeApplyInfoVO.actualAmount !== null) {
        return this.tradeApplyInfoVO.actualAmount
      }
      return this.tradeApplyInfoVO.quoteAmount
    },
    planList () {
      return this.tradeApplyAcceptanceVO.planList || []
    },
    acceptanceList () {
      return this.tradeApplyAcceptanceVO.acceptanceList || []
    },
    tradeApplyAcceptanceVO () {
      return this.tradeApplyInfoVO.tradeApplyAcceptanceVO || {}
    },
    // 报价单
    processOrderList () {
      if (
        this.tradeApplyAcceptanceVO.verifyItemDetailList &&
        this.tradeApplyAcceptanceVO.verifyItemDetailList !== '' && this.tradeApplyAcceptanceVO.verifyItemDetailList !== []
      ) {
        return this.tradeApplyAcceptanceVO.verifyItemDetailList || []
      }
      return this.tradeApplyAcceptanceVO.quoteItemDetailList || []
    },
    // 测量设计报价单
    quoteItemDetailList () {
      return this.tradeApplyAcceptanceVO.quoteItemDetailList || []
    }
  },
  created () { },
  methods: {
    // 查看pdf文件
    handleViewFile (url) {
      window.open(url)
    },
    // 下载报价
    getDownloadQuotation (id) {
      this.exportUrl = commonUtils.getApiUrl(`/bcc/download/${id}`)
      this.$confirm('是否要下载报价单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => { })
      // this.$store
      //   .dispatch("getDownloadQuotation", id)
      //   .then((response) => {
      //     if (response.data) {
      //       let blob = response.data;
      //       const tempLink = document.createElement("a");
      //       tempLink.style.display = "none";
      //       tempLink.href = window.URL.createObjectURL(blob);
      //       tempLink.download = this.tradeApplyBaseVO.pocName + ".excel";
      //       document.body.appendChild(tempLink);
      //       tempLink.click();
      //     } else {
      //       this.$message.error("下载失败，请稍后再试");
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    // 导出历史报价信息
     exportHistory(id){
       this.exportUrl = commonUtils.getApiUrl(`/bcc/download-dsxItemSubmitHistory/${id}`)
       this.$confirm('是否导出历史报价信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => { })
    },
    // 查看报价提交记录
    submitRecord () {
      this.dialogTableVisible = true
      this.$store
        .dispatch('getQuoteSubmissionRecord', this.$route.query.applyId)
        .then((res) => {
          if (res.data.resultCode === '0') {
            // console.log(
            //   res.data.resultData.processRecordList,
            //   '查看报价提交记录'
            // )
            this.processRecordList =
              res.data.resultData.processRecordList || []
          }
        })
    },
    // 查看不同项目报价单
    seeQuatation () {
      this.dialogTableOrderVisible = true
    },
    handleTable (val) {
      if (!val) {
        if (this.shopShowList.length === 3) {
          this.shopShowList = this.shopList
        } else {
          this.shopShowList = this.shopList.slice(0, 3)
        }
      } else if (val === 1) {
        if (this.materialShowList.length === 3) {
          this.materialShowList = this.materialList
        } else {
          this.materialShowList = this.materialList.slice(0, 3)
        }
      }
    },
    initMap (info) {
      const { locLatitude, locLongitude, pocName } = info
      if (!locLatitude || !locLongitude) return
      const map = new AMap.Map('content-map', {
        center: [locLongitude, locLatitude],
        zoom: 16
      })
      const position = new AMap.LngLat(locLongitude, locLatitude)
      const marker = new AMap.Marker({position, map})
      const handleMapClick = AMap.Event.addListener(map, 'click', () => {
        window.open(`https://uri.amap.com/marker?position=${locLongitude},${locLatitude}&name=${pocName}&src=尊享先锋订单平台`)
      })
    },

    setClientType (val) {
      if (val === '01') return 'TMKT'
      if (val === '02') return 'ISP'
      if (val === '03') return 'KA'
      return ''
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    },
    getFile (uri) {
      return commonUtils.getFileUrl(uri)
    },

    getPreviewImageList (list) {
      const imageList = []
      if (list && list.length) {
        list.forEach(item => {
          if (item.acceptanceCode[0] === 'I') {
            imageList.push(this.getImg(item.fileUri))
          }
        })
      }
      return imageList
    }
  }
}
</script>

<style lang="scss" scoped>
 .dialog-button{
  float: right;
  margin-bottom: 20px;
  width: 150px;
  height: 30px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(200, 16, 45, 100);
  font-size: 14px;
  text-align: center;
  font-family: Microsoft Yahei;
  border: 1px solid rgba(200, 16, 45, 100);
 }
.imgWarpTitle {
  text-align: center;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden; /*这个参数根据需求来决定要不要*/
}
.information-title {
  width: 240px;
  display: inline-block;
  overflow: hidden; /*溢出的部分隐藏*/
  white-space: nowrap; /*文本不换行*/
  text-overflow: ellipsis; /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
}
#content-map {
  width: 450px;
  height: 200px;
  border-radius: 8px;
  cursor: pointer;
}
.downBtn {
  border-radius: 4px;
  color: rgba(1, 161, 233, 100);
  font-size: 14px;
  text-align: center;
  margin-top: -10px;
  margin-left: 13px;
  font-family: Microsoft Yahei;
  border: 1px solid rgba(1, 161, 233, 100);
}
.quoteRecord {
  position: absolute;
  left: 990px;
  top: -8px;
  width: 150px;
  height: 30px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(200, 16, 45, 100);
  font-size: 14px;
  text-align: center;
  font-family: Microsoft Yahei;
  border: 1px solid rgba(200, 16, 45, 100);
}
.orderList {
  position: absolute;
  left: 990px;
  top: -8px;
  width: 158px;
  height: 30px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(200, 16, 45, 100);
  font-size: 14px;
  text-align: center;
  font-family: Microsoft Yahei;
  border: 1px solid rgba(200, 16, 45, 100);
}

.detail-file {
  display: flex;
  flex-wrap: wrap;

  .detail-file-content {
    width: 100px;
    margin-right: 20px;
    flex-shrink: 0;
    margin-bottom: 10px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      border-radius: 4px;
    }
  }

  a,
  a:hover {
    color: $base-blue !important;
  }
}
.info-img {
  img {
    width: 200px;
    height: 130px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }
}
.img-wrapper {
  display: inline-block;
  padding-right: 10px;
}
.block-content-table {
  .el-row {
    line-height: 40px;
    text-align: center;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }

  .table-title {
    font-weight: bold;
    background-color: #ebf4ff;
  }

  .table-row-more {
    color: $base-blue;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 8px;
    cursor: pointer;

    .el-icon-arrow-down,
    .el-icon-arrow-up {
      font-weight: bold;
      font-size: 18px;
      padding-right: 2px;
    }
  }
}
.red-col {
  display: flex;
  justify-content: space-around;
  color: rgba(255, 56, 56, 100);
  font-size: 12px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
}
.totalPrice {
  margin-top: 10px;
  margin-bottom: -10px;
  margin-left: 100px;
  font-family: SourceHanSansSC-regular;
  .totalmarginLeft {
    margin-left: 892px;
  }
  span {
    color: rgb(214, 65, 65);
    font-size: 15px;
    font-weight: bold;
  }
}

.box {
  width: 400px;
  .item {
    margin: 4px;
  }
  .right .el-tooltip__popper {
    padding: 8px 10px;
  }
}
</style>
<style lang="scss">
.tps {
  background: rgba(0, 0, 0, 0.6) !important;
  max-width: 180px;
  line-height: 160%;
}
</style>
